import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { Address } from './addresses/Address.js';
export class Company extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Legal name of the organization (optional)
         */
        this.name = '';
        this.VATNumber = null;
        this.companyNumber = null;
        this.address = null;
        this.administrationEmail = null;
    }
    getDiffValue() {
        return this.name;
    }
    equals(other) {
        if (this.name !== other.name) {
            return false;
        }
        if (this.VATNumber !== other.VATNumber) {
            return false;
        }
        if (this.companyNumber !== other.companyNumber) {
            return false;
        }
        if (this.address && other.address) {
            if (!this.address.equals(other.address)) {
                return false;
            }
        }
        else if (!!this.address !== !!other.address) {
            return false;
        }
        if (this.administrationEmail !== other.administrationEmail) {
            return false;
        }
        return true;
    }
}
__decorate([
    field({ decoder: StringDecoder, optional: true, defaultValue: () => uuidv4() })
], Company.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Company.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Company.prototype, "VATNumber", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Company.prototype, "companyNumber", void 0);
__decorate([
    field({ decoder: Address, nullable: true })
], Company.prototype, "address", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], Company.prototype, "administrationEmail", void 0);
//# sourceMappingURL=Company.js.map